import { Component } from 'react'
import s from './Tasks.scss'
import { Task } from './Task'
import cn from 'classnames'
import { If } from 'components/ideal-core-ui'
import { AddButton } from 'components/common/AddButton'

class Tasks extends Component {
  componentDidMount() {
    const { onMountCallback } = this.props
    if (onMountCallback) {
      onMountCallback()
    }
  }

  render() {
    const { tasks, markAsDone, showScheduleTaskModal, markAsNotDone, className } = this.props
    return (
      <>
        <AddButton cy="add_task_btn" className={s.saveBtn} onClick={showScheduleTaskModal}>
          + Schedule a Task
        </AddButton>
        <If
          condition={tasks.length}
          fallback={<p className={s.noTasks}>No tasks yet. Please schedule one.</p>}
        >
          {tasks.map(section => (
            <section key={section.sectionName} className={cn(s.section, className)}>
              {section.sectionName && <label className={s.label}>{section.sectionName}</label>}
              {Object.keys(section.tasks).map(taskCategory => (
                <If key={taskCategory} condition={section.tasks[taskCategory].length}>
                  <section
                    data-cy="tasks_section"
                    className={cn({
                      [s.late]: taskCategory === 'late',
                      [s.today]: taskCategory === 'today',
                      [s.completed]: taskCategory === 'completed'
                    })}
                  >
                    <p className={s.title}>
                      {taskCategory} ({section.tasks[taskCategory].length})
                    </p>
                    {section.tasks[taskCategory].map(task => (
                      <Task
                        markAsDone={markAsDone}
                        markAsNotDone={markAsNotDone}
                        taskCategory={taskCategory}
                        task={task}
                        key={task.id}
                        showScheduleTaskModal={showScheduleTaskModal}
                      />
                    ))}
                  </section>
                </If>
              ))}
            </section>
          ))}
        </If>
      </>
    )
  }
}

export default Tasks
